import {RemoteGetBeneficiary} from 'data/usecases/others/selection-flow/beneficiary-v3';
import {GetBeneficiary} from 'domain/usecases/others/selection-flow/beneficiary-v3';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BeneficiaryEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetBeneficiary = (): GetBeneficiary =>
	new RemoteGetBeneficiary(
		makeBFFApiUrl(BeneficiaryEndpoints.beneficiaryListV3),
		makeAuthorizeHttpClientDecorator(),
	);
